// LiveBadge -- the single source of truth for the green "LIVE" indicator.
//
// Owns BOTH the rule and the look so tiles can't drift apart: it renders only
// during the dashboard session (9:30-16:00 ET, via marketHours.isMarketOpen) and
// carries the shared styling. Returns null when the market is closed, or when a
// tile's own readiness gate (`show`) is false.
//
// Replaces the per-tile `isMarketOpen() && <span className="*-live">LIVE</span>`
// copies that previously lived in MarketIntelligenceFeed, SetupStatus,
// AnalyticsWidgets, FlowGexChart, GexHeatmap and analyticsSections.

import { isMarketOpen } from '../../Utils/marketHours';
import usePlaybackStore from '../../Store/playbackStore';
import '../../Styles/liveBadge.css';

/**
 * @param {boolean} [show=true] - extra per-tile condition (e.g. !loading && !error, hasData).
 * @param {boolean} [push=false] - push to the right edge of a flex header (margin-left:auto).
 * @param {boolean} [dot=false]  - show a green dot before the LIVE label.
 */
export default function LiveBadge({ show = true, push = false, dot = false }) {
  const replaying = usePlaybackStore((s) => s.mode === 'playing');
  if (!show) return null;
  if (!replaying && !isMarketOpen()) return null;
  const cls = [
    'live-badge',
    replaying && 'live-badge--replay',
    push && 'live-badge--push',
    dot && 'live-badge--dot',
  ]
    .filter(Boolean)
    .join(' ');
  return <span className={cls}>{replaying ? 'REPLAY' : 'LIVE'}</span>;
}
